import { render, staticRenderFns } from "./AdminProductAttributesScreen.vue?vue&type=template&id=5ebe5568&scoped=true&"
import script from "./AdminProductAttributesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductAttributesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe5568",
  null
  
)

export default component.exports